
// var base_url = `http://192.168.1.70:8000/api`;


// const api = {
//   imageUrl: `http://192.168.1.70:8000`,

var base_url = `https://narback.hiredeveloper.today/api`;

const api = {
  imageUrl: `http://narback.hiredeveloper.today`,


  //-----------------------------------login / logout
  login: base_url + "/admin/login",
  logout: base_url + "/admin/logout",



  //-----------------------------------add user
  add_user: base_url + "/admin/add-user",

  //-----------------------------------user details
  user_details: base_url + "/admin/user-details",

  //-----------------------------------user delete
  user_delete: base_url + "/admin/delete-user",

  //-----------------------------------user update
  user_update: base_url + "/admin/update-user",



  //-----------------------------------user update
  admin_update: base_url + "/admin/update-profile",



  //-----------------------------------user update
  order_list: base_url + "/admin/order-list",




  //-----------------------------------state details
  state_details: base_url + "/admin/state-details",



  //-----------------------------------add city
  add_city: base_url + "/admin/add-city",

  //-----------------------------------city details
  city_details: base_url + "/admin/city-details",

  //-----------------------------------city delete
  city_delete: base_url + "/admin/delete-city",

  //-----------------------------------city update
  city_update: base_url + "/admin/update-city",




  //-----------------------------------add area
  add_area: base_url + "/admin/add-area",

  //-----------------------------------area details
  area_details: base_url + "/admin/area-details",

  //-----------------------------------area delete
  area_delete: base_url + "/admin/delete-area",

  //-----------------------------------area update
  area_update: base_url + "/admin/update-area",




  //-----------------------------------add product
  add_product: base_url + "/admin/add-product",

  //-----------------------------------get details
  get_product: base_url + "/admin/product-details",

  //-----------------------------------update product
  update_product: base_url + "/admin/add-product",




  //-----------------------------------get stock
  get_stock: base_url + "/admin/stock-details",

  //-----------------------------------update stock
  update_stock: base_url + "/admin/update-stock",




  //-----------------------------------user rights
  get_user_rights: base_url + "/admin/user-rights",

  //-----------------------------------update stock
  update_user_rights: base_url + "/admin/update-user-rights",




  // ----------------order-list

  order_list: base_url + "/admin/order-list",

  // -------------- Sub order list
  sub_order_list: base_url + "/admin/sub-order-list",


  // --------- asign order
  update_sub_order: base_url + "/admin/update-sub-order",

  // ------------------- order details
  order_details: base_url + "/admin/order-details",




  // -------------dashboard count
  dashboard_count: base_url + "/admin/dashboard-count",




  // -------------failed orders
  failed_orders: base_url + "/admin/temp-order-list",




  // -------------transfer order
  transfer: base_url + "/admin/place-order",
  
  
  

    // -------------policies
  policy_details: base_url + "/admin/privacy-details",
  policy_update: base_url + "/admin/update-privacy",
  
  
  

    // -------------dietician request list
    dietician_request_list: base_url + "/admin/dietician-request-list",
    dietician_request_list_update: base_url + "/admin/update-dietician-request",

};

export default api;
